module.exports = __webpack_public_path__ + "img/icon-c-video.93099eb0.svg";